import React, {useEffect, useState,} from "react";
import {Link} from "react-router-dom";






export default  function ItemsDrawer({items,title}) {


    return(
        <div className={'content56-css'}>
            <div className={'main56-title'}>
            {                
            title
            }
            </div>
            {items.map((item)=>
                <Link className={'item56-css'} to={item.url}>
                    <div className={'icon56-css'}>
                        {item.icon}
                    </div>

                    <div className={'title56-css'}>
                        {item.title}
                    </div>



                </Link>

            )

            }

        </div>
    )

}